// extracted by mini-css-extract-plugin
export var link = "_8-0";